// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-page-template-js": () => import("/opt/build/repo/src/templates/page-template.js" /* webpackChunkName: "component---src-templates-page-template-js" */)
}

